<div class="w-100">
  <h5 class="w-100 text-center">You are going to be logged out</h5>
</div>